// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscabairrosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaBairros() /localidades/buscaBairros
 *
 * Proxy to locations-service (Go microservice). Each row mirrors
 * `entity.Neighborhood` from
 * services/locations-service/src/localidades/neighborhood/entity/entity.go.
 */
import type { Localidades_BuscabairrosRow } from './Localidades_BuscabairrosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_BuscabairrosResponseDados = Localidades_BuscabairrosRow[];

export type Localidades_BuscabairrosResponse = ApiResponse<Localidades_BuscabairrosResponseDados>;

registerResponseContract('Localidades_BuscabairrosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:     { type: 'number',  required: false },
      Name:   { type: 'string',  required: false },
      CityID: { type: 'number',  required: false },
      URL:    { type: 'string',  required: false },
    },
  },
})
